import {watch} from "vue";
import {debounce} from 'lodash';
import {useSearchStore} from "@/stores/searchStore";

import * as events from '@/events';
import {useStore} from "vuex";


export function useSynchronizedSearchGeofencesList() {
  const searchStore = useSearchStore();
  const store = useStore();

  watch(searchStore, debounce((value) => {
    store.dispatch('geofence/setSearch', value.normalizedQuery);
    events.trigger(events.names.GEOFENCE_SEARCHED, { query: value.normalizedQuery });
  }, 300), {
    immediate: true,
    flush: 'post',
  })
}
